import React, {useEffect} from "react";
import { useMutation } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { setpublisherGlobalData } from '../../redux/currentpublisher/publisherGlobalDataSlice.js';
import { makeInputs } from '../../util.js';
import CREATE_EXPENSE_CATEGORY_MUTATION from "../../graphql/mutations/PublisherData/CreateExpenseCategory.js";
import AddProductSimple from "../../inputs/select/SelectProduct.js"
import {
  ForeignKeyDropDownInput,
  TextareaFieldInput,
  DateFieldInput,
  CurrencyInput,
  TextInputFieldInput
} from "../../inputs/index.js";

import {
  Pane,
  Card,
  Button,
  toaster
} from 'evergreen-ui';

import { baseExpenseObject } from './BaseExpenseObject.js';

function ExpenseForm(props) {
  const currentpublisher = useSelector((state) => state.currentpublisher.value);
  const publisherGlobalData = useSelector((state) => state.publisherGlobalData.value);
  const dispatch = useDispatch();

  // Initialize staged data first
  console.log('baseExpenseObject:', baseExpenseObject);
  console.log('props.staged before init:', props.staged);

  const initializedStaged = {
    ...baseExpenseObject,
    ...props.staged,
  };

  console.log('initializedStaged after init:', initializedStaged);

  // Debug logs
  console.log('ExpenseForm props:', {
    staged: props.staged,
    editing: props.editing
  });

  console.log('Category input props:', {
    value: initializedStaged.category,
    values: publisherGlobalData.expensecategorys
  });

  const [createExpenseCategory, categoryresult] = useMutation(CREATE_EXPENSE_CATEGORY_MUTATION);

  const handleAddNewExpenseCategory = async (val) => {
    const types = [].concat(publisherGlobalData.expensecategorys);
    try {
      const results = await createExpenseCategory({
        variables: {
          publisherId: String(currentpublisher.id),
          value: val
        }
      });

      const newExpenseCategory = {
        id: results.data.createExpenseCategory.expenseCategory.id,
        value: results.data.createExpenseCategory.expenseCategory.value
      };

      types.push(newExpenseCategory);
      dispatch(setpublisherGlobalData({ expensecategorys: types }));
      props.handleUpdateStaged({ key: "category", val: newExpenseCategory });
    } catch (error) {
      toaster.danger(`Error creating expense category: ${error.message}`);
    }
  }

  // Move inputs definition after initializedStaged
  const inputs = {
    category: {
      width: 250,
      comp: ForeignKeyDropDownInput,
      formLabel: "Expense Category",
      handleChange: props.handleUpdateStaged,
      handleAddNew: handleAddNewExpenseCategory,
      group: 2,
      values: publisherGlobalData.expensecategorys,
      opts: { marginRight: 32, new: true },
      el: "category",
      value: initializedStaged.category
    },
    expenseDate: {
      width: 200,
      comp: DateFieldInput,
      formLabel: "Date",
      handleChange: props.handleUpdateStaged,
      group: 1,
      opts: { marginRight: 32 }
    },
    amount: {
      width: 150,
      comp: CurrencyInput,
      formLabel: "Amount",
      handleChange: props.handleUpdateStaged,
      group: 1,
      opts: { marginRight: 32, autoFocus: true }
    },
    adminNotes: {
      width: 400,
      comp: TextareaFieldInput,
      formLabel: "Notes",
      handleChange: props.handleUpdateStaged,
      group: 3
    },
  }

  const handleChangeWithUpdate = (key, val) => {
    props.handleUpdateStaged({ key, val });
  };

  // Generate form inputs
  const formInputs = makeInputs(initializedStaged, inputs, props.editing);

  // Debugging: Log the formInputs structure
  console.log('Form Inputs:', formInputs);

  useEffect(() => {
    if (categoryresult.loading) {
      toaster.notify("Creating category...", { duration: 60 });
      console.log(categoryresult)
    }
    if (categoryresult.called && !categoryresult.error) {
      toaster.closeAll();
      toaster.success("Category saved!", { duration: 1 });

    } else if (categoryresult.error){
      toaster.closeAll();
      toaster.notify("Error Creating New Category");
    }
  },[categoryresult])

  // Add prop validation/default handler
  const handleClear = () => {
    if (props.handleClearStaged) {
      props.handleClearStaged();
    }

    if (props.newMode && props.handleToggleNewMode) {
      props.handleToggleNewMode();
    }
  };

  return (
    <Card display={props.newMode ? "flex" : "inline-flex"} padding={16} margin={8} backgroundColor="white" elevation={2} >
      <Pane>
        {/* Group 1 - Date and Amount */}
        <Pane display="flex">
          {formInputs.group1 || <p>No group1 inputs</p>}
        </Pane>

        {/* Group 2 - Category and Product Selector */}
        <Pane display="flex">
          {formInputs.group2 || <p>No group2 inputs</p>}
          <AddProductSimple
            handleAttachProduct={props.handleAttachProduct}
            product={initializedStaged.product}
            editing={props.editing}
            parent="expenses"
          />
        </Pane>

        {/* Group 3 - Description and Notes */}
        <Pane display="flex">
          {formInputs.group3 || <p>No group3 inputs</p>}
        </Pane>

        {/* Action Buttons */}
        <Pane display="flex" flexDirection="row" justifyContent="flex-start">
          {props.newMode ? (
            <Button
              className="confirm-button"
              disabled={props.disableSave}
              marginRight={16}
              onClick={() => {
                if (!initializedStaged.product?.id && !initializedStaged.category?.id) {
                  props.handleProductError();
                } else {
                  props.handleCreateExpense();
                }
              }}
            >
              CREATE EXPENSE
            </Button>
          ) : null}
          <Button onClick={handleClear}>
            {props.newMode ? 'Cancel' : 'RESET'}
          </Button>
        </Pane>
      </Pane>
    </Card>
  )
}

// Add prop type checking if you're using PropTypes
ExpenseForm.defaultProps = {
  handleClearStaged: () => {},
  handleToggleNewMode: () => {},
  newMode: false
};

export default ExpenseForm;
